// extracted by mini-css-extract-plugin
export var layoutContainer = "_3y-0";
export var layoutContainerNoRounding = "_3y-6";
export var layoutContainerOpen = "_3y-5";
export var layoutContainerResizing = "_3y-1";
export var mainContent = "_3y-2";
export var resizeDivider = "_3y-3";
export var slidePanel = "_3y-4";